module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_library.js
// module id = 162
// module chunks = 168707334958949